import { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import axios from 'axios';

const SensoresPorTipo = () => {
  const { tipo } = useParams();
  const { logout } = useContext(AuthContext);
  const [sensores, setSensores] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchByTipo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await axios.get(
          `https://elicromiot.com/api/sensor/tipo/${tipo}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setSensores(response.data);
      } catch (error) {
        setError('Error al cargar sensores.');
      }
    };

    fetchByTipo();
  }, [tipo]);

  const handleSensorClick = (id) => navigate(`/sensor/${id}`);
  const handleBack = () => navigate('/seleccionar-tipo');
  const goToReport = () => navigate('/report');

  const renderTableHeaders = () => {
    switch (tipo) {
      case 'HumedadTemperatura':
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
            <th style={styles.th}>Temperatura (°C)</th>
            <th style={styles.th}>Humedad (%)</th>
          </>
        );
      case 'CalidadAgua':
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
            <th style={styles.th}>pH</th>
            <th style={styles.th}>Conductividad (µS/cm)</th>
            <th style={styles.th}>Turbidez (NTU)</th>
            <th style={styles.th}>Temperatura (°C)</th>
            <th style={styles.th}>Sólidos (mg/L)</th>
          </>
        );
      case 'Temperatura':
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
            <th style={styles.th}>Temperatura (°C)</th>
          </>
        );
      case 'Nivel':
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
            <th style={styles.th}>Nivel (m)</th>
          </>
        );
      case 'Flujo':
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
            <th style={styles.th}>Flujo (L/min)</th>
          </>
        );
      default:
        return (
          <>
            <th style={styles.th}>Nombre</th>
            <th style={styles.th}>Tipo</th>
            <th style={styles.th}>DevEUI</th>
          </>
        );
    }
  };

  const renderTableCells = (sensor) => {
    switch (tipo) {
      case 'HumedadTemperatura':
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
            <td style={styles.td}>{sensor.last_reading ?? 'N/A'}</td>
            <td style={styles.td}>{sensor.last_secondary_reading ?? 'N/A'}</td>
          </>
        );
      case 'CalidadAgua':
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
            <td style={styles.td}>{sensor.ph ?? 'N/A'}</td>
            <td style={styles.td}>{sensor.conductividad ?? 'N/A'}</td>
            <td style={styles.td}>{sensor.turbidez ?? 'N/A'}</td>
            <td style={styles.td}>{sensor.temperatura ?? 'N/A'}</td>
            <td style={styles.td}>{sensor.solidos ?? 'N/A'}</td>
          </>
        );
      case 'Temperatura':
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
            <td style={styles.td}>{sensor.last_reading ?? 'N/A'}</td>
          </>
        );
      case 'Nivel':
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
            <td style={styles.td}>{sensor.last_reading ?? 'N/A'}</td>
          </>
        );
      case 'Flujo':
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
            <td style={styles.td}>{sensor.last_reading ?? 'N/A'}</td>
          </>
        );
      default:
        return (
          <>
            <td style={styles.td}>{sensor.nombre}</td>
            <td style={styles.td}>{sensor.tipo}</td>
            <td style={styles.td}>{sensor.deveui}</td>
          </>
        );
    }
  };

  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>⬅️ Volver</button>
      <h2 style={styles.title}>Sensores de tipo: {tipo}</h2>
      {error && <p style={styles.error}>{error}</p>}
      {!error && sensores.length === 0 && (
        <p style={styles.noData}>No hay sensores disponibles para este tipo.</p>
      )}
      {sensores.length > 0 && (
        <table style={styles.table}>
          <thead>
            <tr>{renderTableHeaders()}</tr>
          </thead>
          <tbody>
            {sensores.map(sensor => (
              <tr key={sensor.id} onClick={() => handleSensorClick(sensor.id)} style={styles.row}>
                {renderTableCells(sensor)}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div style={styles.reportButtonContainer}>
        <button onClick={goToReport} style={styles.reportButton}>
          📄 Generar Reporte
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '40px',
    backgroundColor: '#e6f2ff',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  backButton: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '20px',
    transition: 'background-color 0.3s',
  },
  title: {
    color: '#1e3a8a',
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '28px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  th: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    padding: '12px',
    textAlign: 'left',
    fontSize: '16px',
  },
  td: {
    padding: '12px',
    textAlign: 'left',
    fontSize: '14px',
  },
  row: {
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  noData: {
    textAlign: 'center',
    color: '#888',
    marginTop: '20px',
    fontSize: '18px',
  },
  error: {
    textAlign: 'center',
    color: 'red',
    fontSize: '18px',
  },
  reportButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
  },
  reportButton: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    border: 'none',
    transition: 'background-color 0.3s',
  }
};

export default SensoresPorTipo;
